import { booleanParser } from './booleanParser';

/**
 * @typedef {Object} WalletConfig
 * @property {number[]} REACT_APP_WALLET_ID - Main wallet IDs
 * @property {number[]} REACT_APP_BTN_WALLET_ID - Button wallet IDs
 */

/**
 * @typedef {Object} ServiceConfig
 * @property {number[]} REACT_APP_ENTEKHAB_IDS - Entekhab service IDs
 * @property {number[]} REACT_APP_KEEPA_MEHR_IDS - Keepa Mehr service IDs
 * @property {number[]} REACT_APP_ENTEKHAB_MEHR_IDS - Entekhab Mehr service IDs
 * @property {number[]} REACT_APP_MEDU_IDS - Medu service IDs
 * @property {number[]} REACT_APP_MELI_IDS - Meli service IDs
 * @property {number[]} REACT_APP_SINA_IDS - Sina service IDs
 * @property {number[]} REACT_APP_BLU_IDS - Blu service IDs
 * @property {number[]} REACT_APP_TARA_IDS - Tara service IDs
 * @property {number[]} REACT_APP_REFAH_IDS - Refah service IDs
 * @property {number[]} REACT_APP_TANTAK_IDS - Tantak service IDs
 * @property {number[]} REACT_APP_SABAHLEND_IDS - Sabahlend service IDs
 * @property {number[]} REACT_APP_REFAHYAR_IDS - Refahyar service IDs
 * @property {number[]} REACT_APP_FARA_IDS - Fara service IDs
 * @property {number[]} REACT_APP_HAMTALAND_IDS - Hamtaland service IDs
 * @property {number[]} REACT_APP_RAYANSAIPA_IDS - Rayansaipa service IDs
 * @property {number[]} REACT_APP_GHESTANE_IDS - Ghestane service IDs
 * @property {number[]} REACT_APP_CAN_IDS - Can service IDs
 * @property {number[]} REACT_APP_DEMO_IDS - Demo service IDs
 * @property {number[]} REACT_APP_TISA_IDS - Tisa service IDs
 * @property {number[]} REACT_APP_SAANA_IDS - Saana service IDs
 * @property {number[]} REACT_APP_SHOPP_IDS - Shopp service IDs
 * @property {number[]} REACT_APP_ARBAEEN_IDS - Arbaeen service IDs
 * @property {number[]} REACT_APP_DANESH_IDS - Danesh service IDs
 * @property {number[]} REACT_APP_KARMA_IDS - Karma service IDs
 * @property {number[]} REACT_APP_HASTESH_IDS - Hastesh service IDs
 */

/** @type {Object.<string, number[]>} */
const TEST_SERVER_CONFIG = {
	WALLET: [
		111111171, 111111169, 111111168, 111111172, 111111173, 111111174, 111111175, 111111179, 111111182,
		111111184, 111111188, 111111191, 111111214, 111111221, 111111224, 111111228, 111111261, 111111265,
		111111271, 111111279,
	],
	ENTEKHAB: [111111169, 111111172, 111111177, 111111181, 111111183],
	KEEPA_MEHR: [111111168],
	ENTEKHAB_MEHR: [111111182],
	MEDU: [111111171],
	MELI: [111111173],
	SINA: [111111174],
	BLU: [111111175],
	TARA: [111111179],
	REFAH: [],
	TANTAK: [111111184, 111111188, 111111191],
	SABAHLEND: [],
	REFAHYAR: [],
	FARA: [111111116, 111111121, 111111122, 111111125, 111111136, 111111137, 111111144],
	HAMTALAND: [111111195, 111111196, 111111271],
	RAYANSAIPA: [111111219, 111111221, 111111223, 111111224],
	GHESTANE: [111111213, 111111214],
	DEMO: [],
	TISA: [111111225, 111111227, 111111251],
	SAANA: [111111286],
	SHOPP: [111111282],
	ARBAEEN: [111111279],
	DANESH: [111111272],
	HASTESH: [111111226, 111111228, 111111229],
	ARMANPAY: [111111231, 111111254],
	CALKO: [111111268, 111111277],
	LENDAVID: [111111242],
	FLYTODAY: [111111261, 111111262],
	CAN: [111111265, 111111267],
	KARMA: [],
};

/** @type {Object.<string, number[]>} */
const MAIN_SERVER_CONFIG = {
	WALLET: [
		111111174, 111111173, 111111179, 111111181, 111111184, 111111186, 111111188, 111111195, 111111196,
		111111191, 111111213, 111111215, 111111228, 111111236, 111111236, 111111237, 111111241, 111111245,
		111111258, 111111274, 111111271, 111111288,
	],
	ENTEKHAB: [
		111111174, 111111191, 111111175, 111111178, 111111182, 111111183, 111111185, 111111187, 111111189,
		111111192, 111111194,
	],
	KEEPA_MEHR: [111111173],
	SINA: [111111195],
	MELI: [111111179],
	BLU: [111111184],
	MEDU: [111111181],
	TARA: [111111186],
	REFAH: [],
	ENTEKHAB_MEHR: [111111188],
	TANTAK: [111111196, 111111213, 111111215],
	SABAHLEND: [111111211],
	REFAHYAR: [111111199, 111111198],
	FARA: [111111125, 111111136, 111111162],
	HAMTALAND: [111111221, 111111222, 111111271],
	RAYANSAIPA: [111111236, 111111237, 111111226, 111111239, 111111241],
	GHESTANE: [111111227, 111111228, 111111229],
	DEMO: [111111232],
	TISA: [111111238, 111111243, 111111248, 111111249, 111111251, 111111315],
	SAANA: [111111293],
	SHOPP: [111111291],
	ARBAEEN: [111111288],
	DANESH: [111111275],
	HASTESH: [111111242, 111111244, 111111245],
	ARMANPAY: [111111246, 111111255],
	CALKO: [111111165, 111111278],
	LENDAVID: [111111247],
	FLYTODAY: [111111258, 111111259],
	CAN: [111111274, 111111273],
	KARMA: [111111283, 111111284, 111111285],
};

/**
 * Creates the environment configuration based on the server type
 * @param {Object.<string, number[]>} config - The server configuration object
 * @returns {WalletConfig & ServiceConfig} The complete environment configuration
 */
const createEnvConfig = (config) => ({
	REACT_APP_WALLET_ID: config.WALLET,
	REACT_APP_BTN_WALLET_ID: config.WALLET,
	REACT_APP_ENTEKHAB_IDS: config.ENTEKHAB,
	REACT_APP_KEEPA_MEHR_IDS: config.KEEPA_MEHR,
	REACT_APP_ENTEKHAB_MEHR_IDS: config.ENTEKHAB_MEHR,
	REACT_APP_MEDU_IDS: config.MEDU,
	REACT_APP_MELI_IDS: config.MELI,
	REACT_APP_SINA_IDS: config.SINA,
	REACT_APP_BLU_IDS: config.BLU,
	REACT_APP_TARA_IDS: config.TARA,
	REACT_APP_REFAH_IDS: config.REFAH,
	REACT_APP_TANTAK_IDS: config.TANTAK,
	REACT_APP_SABAHLEND_IDS: config.SABAHLEND,
	REACT_APP_REFAHYAR_IDS: config.REFAHYAR,
	REACT_APP_FARA_IDS: config.FARA,
	REACT_APP_HAMTALAND_IDS: config.HAMTALAND,
	REACT_APP_RAYANSAIPA_IDS: config.RAYANSAIPA,
	REACT_APP_GHESTANE_IDS: config.GHESTANE,
	REACT_APP_DEMO_IDS: config.DEMO,
	REACT_APP_TISA_IDS: config.TISA,
	REACT_APP_SAANA_IDS: config.SAANA,
	REACT_APP_SHOPP_IDS: config.SHOPP,
	REACT_APP_ARBAEEN_IDS: config.ARBAEEN,
	REACT_APP_DANESH_IDS: config.DANESH,
	REACT_APP_KARMA_IDS: config.KARMA,
	REACT_APP_HASTESH_IDS: config.HASTESH,
	REACT_APP_ARMANPAY_IDS: config.ARMANPAY,
	REACT_APP_CALKO_IDS: config.CALKO,
	REACT_APP_LENDAVID_IDS: config.LENDAVID,
	REACT_APP_FLYTODAY_IDS: config.FLYTODAY,
	REACT_APP_CAN_IDS: config.CAN,
});

const CONST_ENV = createEnvConfig(
	booleanParser(process.env.REACT_APP_TEST_SERVER) ? TEST_SERVER_CONFIG : MAIN_SERVER_CONFIG,
);

export default CONST_ENV;
